import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Map, TrendingUp, Award, Brain, Sparkles, Users, ArrowRight } from "lucide-react";

const benefits = [
  { icon: Map, title: "Learning Paths", desc: "Step-by-step guided journeys for every age.", color: "from-cyan-400 to-teal-400" },
  { icon: TrendingUp, title: "Progress Tracking", desc: "See stars, streaks and skills grow daily.", color: "from-emerald-400 to-green-500" },
  { icon: Award, title: "Badges & Rewards", desc: "Earn stars and badges for every milestone.", color: "from-amber-400 to-orange-400" },
  { icon: Brain, title: "Brain Challenges", desc: "Daily puzzles that sharpen thinking.", color: "from-violet-400 to-fuchsia-500" },
  { icon: Sparkles, title: "Premium Activities", desc: "Unlimited games, worksheets and stories.", color: "from-pink-400 to-rose-500" },
  { icon: Users, title: "Parent Dashboard", desc: "Track your child's learning at a glance.", color: "from-blue-400 to-indigo-500" },
];

const PremiumBenefits = () => {
  return (
    <section className="py-10 md:py-14 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-8">
          <span className="inline-block bg-amber-100 border border-amber-300 text-amber-800 text-xs font-bold uppercase tracking-wide px-3 py-1 rounded-full mb-3">
            ✨ Premium Experience
          </span>
          <h2 className="text-2xl md:text-4xl font-fredoka font-bold text-gray-900 mb-2">
            Everything Your Child Needs to Thrive
          </h2>
          <p className="text-gray-600 font-quicksand text-sm md:text-base max-w-2xl mx-auto">
            A complete SaaS learning platform built for kids ages 3–10 and the parents who guide them.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-3 md:gap-4 max-w-5xl mx-auto">
          {benefits.map((b, i) => {
            const Icon = b.icon;
            return (
              <motion.div
                key={b.title}
                initial={{ opacity: 0, y: 16 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.05 }}
                whileHover={{ y: -3 }}
                className="bg-white rounded-2xl border-2 border-gray-100 hover:border-cyan-200 hover:shadow-lg transition-all p-4 md:p-5"
              >
                <div className={`w-10 h-10 md:w-12 md:h-12 rounded-xl bg-gradient-to-br ${b.color} flex items-center justify-center shadow-sm mb-3`}>
                  <Icon className="w-5 h-5 md:w-6 md:h-6 text-white" />
                </div>
                <h3 className="font-fredoka font-bold text-sm md:text-base text-gray-900 mb-1">
                  {b.title}
                </h3>
                <p className="text-xs md:text-sm text-gray-600 font-quicksand leading-snug">
                  {b.desc}
                </p>
              </motion.div>
            );
          })}
        </div>

        <div className="text-center mt-8">
          <Link
            to="/pricing"
            className="inline-flex items-center gap-2 bg-amber-400 hover:bg-amber-500 text-white font-fredoka font-bold px-6 py-3 rounded-full shadow-md hover:shadow-lg transition-all"
          >
            See Premium Plans <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default PremiumBenefits;
